import { getApi } from '@BUP/services/Axios'

export const fetchAll = tags => async () => {
  const client = await getApi('schools', { version: 3 })
  return client
    .get(`topics?filter[tags]=${tags}`)
    .then(response => response.data)
}
